const PATH = 'fe.components.activate_product_key';

const messages = {
  productKey: {
    key: `${PATH}.product_key`,
    defaultValue: 'Product Key'
  },
  activateProductKey: {
    key: `${PATH}.activate_product_key`,
    defaultValue: 'Activate Product Key'
  },
  activate: {
    key: `${PATH}.activate`,
    defaultValue: 'Activate'
  },
  cancel: {
    key: `${PATH}.cancel`,
    defaultValue: 'Cancel'
  },
  tokenRedemption: {
    title: {
      key: `${PATH}.token_redemption.title`,
      defaultValue: 'Activate this token again?'
    },
    previousActivation: {
      key: `${PATH}.token_redemption.previous_activation`,
      defaultValue: 'You previously activated this Product Key on {{date}}.'
    },
    findCalibrations: {
      key: `${PATH}.token_redemption.find_calibrations`,
      defaultValue: 'You can find your calibrations listed in'
    },
    calibrationsLink: {
      key: `${PATH}.token_redemption.calibrations_link`,
      defaultValue: 'your calibration videos'
    },
    anotherVideo: {
      key: `${PATH}.token_redemption.another_video`,
      defaultValue:
        'By activating this Product Key now, you will receive another {{edition}} {{ageLevel}} video.'
    },
    activateAgain: {
      key: `${PATH}.token_redemption.activate_again`,
      defaultValue: 'Activate again'
    },
    close: {
      key: `${PATH}.token_redemption.close`,
      defaultValue: 'Close'
    },
    firstEdition: {
      key: `${PATH}.token_redemption.first_edition`,
      defaultValue: '2008'
    },
    secondEdition: {
      key: `${PATH}.token_redemption.second_edition`,
      defaultValue: '2nd Edition'
    },
    preKThird: {
      key: `${PATH}.token_redemption.pre_k_third`,
      defaultValue: 'Pre-K–3rd'
    },
    ageNeutral: {
      key: `${PATH}.token_redemption.age_neutral`,
      defaultValue: 'Age Neutral'
    }
  },
  errors: {
    required: {
      key: `${PATH}.errors.required`,
      defaultValue: 'Please enter a product key'
    },
    ineligible: {
      key: `${PATH}.errors.ineligible`,
      defaultValue:
        'You are ineligible to use this product key. Please contact Customer Support.'
    },
    unknownError: {
      key: `${PATH}.errors.unknown_error`,
      defaultValue:
        'Error activating product key, please contact customer support or try again.'
    },
    noAvailable: {
      key: `${PATH}.errors.no_available`,
      defaultValue:
        'This product key is no longer available. Please contact Customer Support for assistance.'
    }
  }
};

export default messages;
